export const ACCESSTOKENLOCALSTORAGE = "ACCESSTOKENLOCALSTORAGE";

export const OAUTHGOOGLECSRFTOKEN = 'OAUTHGOOGLECSRFTOKEN'
export const OAUTHREDIRECT = 'OAUTHREDIRECT'